import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { Spiner } from "@components/loaders/spiner";
// moment.locale("id");
export const SulukDataPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_SULUK, nis],
    queryFn: () => SchoolService.studentSuluk({ nis }),
  });

  const getScore = (totpoin: number) => {
    const scores = [
      { min: 150, value: 100 },
      { min: 130, value: 95 },
      { min: 105, value: 90 },
      { min: 55, value: 85 },
      { min: 5, value: 80 },
      { min: 0, value: 75 },
      { min: -60, value: 70 },
      { min: -130, value: 65 },
      { min: -175, value: 60 },
    ];

    const score = scores.find((range) => totpoin >= range.min)?.value;
    return score ?? (totpoin < -176 ? 55 : "-");
  };

  useEffect(() => {
    setAppBar({ title: "Rekap Suluk", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rekap Suluk",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          {isPending ? (
            <div className="tw-text-center">
              <Spiner />
            </div>
          ) : (
            <>
              <div className="tw-text-primary-hg tw-text-xs">NIS</div>
              <div className="tw-mb-3">{nis}</div>
              <div className="tw-text-primary-hg tw-text-xs">Nama Siswa</div>
              <div className="tw-mb-3">{data?.data[0]?.namasiswa ?? "-"}</div>

              <div className="tw-text-primary-hg tw-text-xs">
                Jenjang / Kelas / Kamar
              </div>
              <div className="tw-mb-3">
                {data?.data[0]?.marhalah ?? "-"} / {data?.data[0]?.kelas ?? "-"}{" "}
                / {data?.data[0]?.namakamar ?? "-"}
              </div>

              <div className="tw-text-primary-hg tw-text-xs">Musyrif</div>
              <div className="tw-mb-3">{data?.data[0]?.musyrif ?? "-"}</div>

              <div className="tw-text-primary-hg tw-text-xs">Wali Kelas</div>
              <div className="tw-mb-3">
                {data?.data[0]?.namawalikelas ?? "-"}
              </div>

              <div className="tw-text-primary-hg tw-text-xs">Total Poin</div>
              <div className="tw-mb-3">{data?.data[0]?.totalnilai ?? 0}</div>

              <div className="tw-text-primary-hg tw-text-xs">Nilai Suluk</div>
              <div className="tw-mb-3">
                {getScore(data?.data[0]?.totalnilai ?? 0)}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
